import { CategoryData } from '../../../../types/types';

export const verbes: CategoryData = {
    // Actions quotidiennes
    'Kotambola (Marcher)': {
        translation: 'Marcher',
        translationEn: 'To walk',
        illustration: '🚶',
        audio: 'Li-kotambola'
    },
    'Kolia (Manger)': {
        translation: 'Manger',
        translationEn: 'To eat',
        illustration: '🍽️',
        audio: 'Li-kolia'
    },
    'Kolala (Dormir)': {
        translation: 'Dormir',
        translationEn: 'To sleep',
        illustration: '😴',
        audio: 'Li-kolala'
    },
    'Komela (Boire)': {
        translation: 'Boire',
        translationEn: 'To drink',
        illustration: '🥤',
        audio: 'Li-komela'
    },
    'Kotelema (Se lever)': {
        translation: 'Se lever',
        translationEn: 'To get up',
        illustration: '🧍',
        audio: 'Li-kotelema'
    },
    'Kovanda (S\'asseoir)': {
        translation: 'S\'asseoir',
        translationEn: 'To sit down',
        illustration: '💺',
        audio: 'Li-kovanda'
    },

    // Communication
    'Koloba (Parler)': {
        translation: 'Parler',
        translationEn: 'To speak',
        illustration: '🗣️',
        audio: 'Li-koloba'
    },
    'Koyoka (Écouter)': {
        translation: 'Écouter',
        translationEn: 'To listen',
        illustration: '👂',
        audio: 'Li-koyoka'
    },
    'Kokoma (Écrire)': {
        translation: 'Écrire',
        translationEn: 'To write',
        illustration: '✍️',
        audio: 'Li-kokoma'
    },
    'Kotuna (Demander)': {
        translation: 'Demander',
        translationEn: 'To ask',
        illustration: '❓',
        audio: 'Li-kotuna'
    },
    'Koyanola (Répondre)': {
        translation: 'Répondre',
        translationEn: 'To answer',
        illustration: '💬',
        audio: 'Li-koyanola'
    },

    // Actions de déplacement
    'Kopota mbangu (Courir)': {
        translation: 'Courir',
        translationEn: 'To run',
        illustration: '🏃',
        audio: 'Li-kopotambangu'
    },
    'Koya (Venir)': {
        translation: 'Venir',
        translationEn: 'To come',
        illustration: '👈',
        audio: 'Li-koya'
    },
    'Kokende (Aller)': {
        translation: 'Aller',
        translationEn: 'To go',
        illustration: '👉',
        audio: 'Li-kokende'
    },
    'Kobima (Sortir)': {
        translation: 'Sortir',
        translationEn: 'To go out',
        illustration: '🚪',
        audio: 'Li-kobima'
    },
    'Kokota (Entrer)': {
        translation: 'Entrer',
        translationEn: 'To enter',
        illustration: '🚪',
        audio: 'Li-kokota'
    },
    'Kozonga (Revenir)': {
        translation: 'Revenir',
        translationEn: 'To come back',
        illustration: '🔙',
        audio: 'Li-kozonga'
    },

    // États et sentiments
    'Kozala malamu (Être en bonne santé)': {
        translation: 'Être en bonne santé',
        translationEn: 'To be in good health',
        illustration: '😊',
        audio: 'Li-kozalamalamu'
    },
    'Kosepela (Être content)': {
        translation: 'Être content',
        translationEn: 'To be happy',
        illustration: '😃',
        audio: 'Li-kosepela'
    },
    'Koyoka pasi (Avoir mal)': {
        translation: 'Avoir mal',
        translationEn: 'To be in pain',
        illustration: '🤕',
        audio: 'Li-koyokapasi'
    },
    'Kokanga motema (Être fâché)': {
        translation: 'Être fâché',
        translationEn: 'To be angry',
        illustration: '😠',
        audio: 'Li-kokanga_motema'
    },
    'Kolinga (Aimer)': {
        translation: 'Aimer',
        translationEn: 'To love',
        illustration: '❤️',
        audio: 'Li-kolinga'
    },

    // Activités domestiques
    'Kosala (Travailler)': {
        translation: 'Travailler',
        translationEn: 'To work',
        illustration: '💼',
        audio: 'Li-kosala'
    },
    'Kokamba (Cuisiner)': {
        translation: 'Cuisiner',
        translationEn: 'To cook',
        illustration: '👩‍🍳',
        audio: 'Li-kokamba'
    },
    'Kokangola (Ouvrir)': {
        translation: 'Ouvrir',
        translationEn: 'To open',
        illustration: '🗝️',
        audio: 'Li-kokangola'
    },
    'Kokanga (Fermer)': {
        translation: 'Fermer',
        translationEn: 'To close',
        illustration: '🔒',
        audio: 'Li-kokanga'
    },
    'Kopetola (Nettoyer)': {
        translation: 'Nettoyer',
        translationEn: 'To clean',
        illustration: '🧹',
        audio: 'Li-kopetola'
    },
    'Kosukola (Laver)': {
        translation: 'Laver',
        translationEn: 'To wash',
        illustration: '🧺',
        audio: 'Li-kosukola'
    },

    // Autres verbes utiles
    'Koyeba (Savoir / Connaître)': {
        translation: 'Savoir / Connaître',
        translationEn: 'To know',
        illustration: '🧠',
        audio: 'Li-koyeba'
    },
    'Kokanisa (Penser)': {
        translation: 'Penser',
        translationEn: 'To think',
        illustration: '🤔',
        audio: 'Li-kokanisa'
    },
    'Kotalela (Regarder)': {
        translation: 'Regarder',
        translationEn: 'To watch/To look',
        illustration: '👀',
        audio: 'Li-kotalela'
    },
    'Kokosa (Mentir)': {
        translation: 'Mentir',
        translationEn: 'To lie',
        illustration: '🤥',
        audio: 'Li-kokosa'
    },
    'Kobondela (Prier)': {
        translation: 'Prier',
        translationEn: 'To pray',
        illustration: '🙏',
        audio: 'Li-kobondela'
    }
};

export default verbes;
